
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(365|52|734|976)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
